import React, { Component } from "react";

const CheckCircleIcon = ({ width, color, fill }) => {
  return (
    <svg
      width={width}
      height={width}
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="9.5" cy="9.5" r="9.5" fill={color} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.55005 13.7213L15.2 7.07136L13.8271 5.70006L8.55005 10.9771L5.59432 8.12709L4.22137 9.50004L8.55005 13.7213ZM9.50004 8.34567e-05C11.379 8.34567e-05 13.2157 0.557246 14.7779 1.60111C16.3402 2.64498 17.5578 4.12867 18.2769 5.86456C18.9959 7.60045 19.184 9.51058 18.8175 11.3534C18.4509 13.1962 17.5461 14.8889 16.2175 16.2175C14.8889 17.5461 13.1962 18.4509 11.3534 18.8175C9.51058 19.184 7.60045 18.9959 5.86456 18.2769C4.12867 17.5578 2.64498 16.3402 1.60111 14.7779C0.557246 13.2157 8.34567e-05 11.379 8.34567e-05 9.50004C-0.00516276 8.25102 0.23698 7.01332 0.712539 5.85837C1.1881 4.70341 1.88766 3.65406 2.77086 2.77086C3.65406 1.88766 4.70341 1.1881 5.85837 0.712539C7.01332 0.23698 8.25102 -0.00516276 9.50004 8.34567e-05Z"
        fill={fill}
      />
    </svg>
  );
};

CheckCircleIcon.defaultProps = {
  width: 13,
  fill: "black",
  color: "white",
};

export default CheckCircleIcon;
